var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-3 secondary--text text--darken-3",attrs:{"disabled":(!_vm.model.status.valid) || _vm.disabled || _vm.model.status.disabled,"color":"primary","type":"submit"}},[_vm._v("\n\n    "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }